<li class="me-0" (click)="this.handleClickOnAtecoResult()">
    <div class="option" [class.focus]="this.hasFocus">
        <div class="d-flex">
            <!-- IMMAGINI AGENTE -->
            <ng-container
                *ngIf="result.type === 'agent' || result.type === 'agency' || (result.professionist !== null && result.professionist !== undefined)">
                <ng-container *ngIf="profileImg != 'undefined' &&  profileImg !== null && profileImg !==''">
                    <img class="agentimg agentimg--test" [style.width]="0" [style.height]="0" loading="lazy"
                        [src]="profileImg" alt="" (error)="this.handleBrokenLogo(this.result?.name)">
                </ng-container>
                <ng-container
                    *ngIf="profileImg != 'undefined' && profileImg !== null && profileImg !== '' && !this.checkBrokenLogo(this.result?.name)">
                    <div class="agentimg agentimg--official position-relative">
                        <img [ngSrc]="profileImg || 'assets/img/placeholder/agent.jpg'" alt="immagine agente cercacasa"
                            fill="center">
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="profileImg == 'undefined' || profileImg === null || profileImg === '' || this.checkBrokenLogo(this.result?.name)">
                    <div class="agentimg agentimg--brokenLogo d-flex align-items-center justify-content-center">
                        <i [class.icon-user-tie]="result.type === 'agent' || (result.professionist !== null && result.professionist !== undefined)"
                            [class.icon-building]="result.type === 'agency'" class="icon-user-tie"></i>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="result.type === 'ateco_company' || result.type === 'ateco_company_agent'">
                <div class="agentimg agentimg--brokenLogo d-flex align-items-center justify-content-center">
                    <i [class.icon-user-tie]="result.type === 'agent' || result.type === 'ateco_company_agent'"
                        [class.icon-building]="result.type === 'agency' || result.type === 'ateco_company'"></i>
                </div>
            </ng-container>

            <div class="w-100 d-flex align-items-between flex-column">
                <p *ngIf="result?.type === 'agent' || result?.type === 'agency'" class="m-0 p-0"><b>{{result.name |
                        titlecase}}</b>
                    {{subtitle}}
                    <ng-container *ngIf="result.type === 'agent'">
                        {{this.main.getAssociationName(result.type === 'agent' ? result?.data?.agent?.association :
                        result?.data?.agency?.association)}}
                    </ng-container>
                </p>
                <!-- ATECO -->
                <p *ngIf="result?.type === 'ateco_company' || result?.type === 'ateco_company_agent'" class="m-0 p-0">
                    <b>{{result.name}}</b> {{result?.type === 'ateco_company_agent' ? ' • ' +
                    result.data?.ragioneSociale :
                    ''}}{{this.main.getCityRegex(result.data.indirizzoCompleto)}}
                </p>
                <!------------>
                <!-- PROFESSIONISTI -->
                <p *ngIf="result?.professionist" class="m-0 p-0">
                    <b>{{result.full_name}}</b> • {{result.professionist?.brand?.name}}
                    •
                    Consulente del credito-mutui-prestiti-assicurazioni
                </p>
                <!------------>

                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <app-badge *ngIf="result?.data?.agent?.isTop || result?.data?.agency?.isTop" [showText]="true"
                            [badgeType]="'agente-top'"></app-badge>
                        <b [class.ms-2]="result?.data?.agent?.isTop || result?.data?.agency?.isTop"
                            class="mb-0">{{result?.type === 'agent' || result?.type === 'ateco_company_agent' ? 'Agente'
                            : result?.type === 'agency' || result?.type === 'ateco_company' ? 'Agenzia' : ''}}</b>
                    </div>
                    <img *ngIf="result?.type === 'agent' || result?.type === 'agency'" class="logo-cercacasa-small ms-2"
                        width="110" height="18" [ngSrc]="'assets/img/logoblu.png'" alt="logo cercacsa">
                </div>
            </div>
        </div>
    </div>
</li>